import Vue from 'vue'
import Clipboard from 'clipboard'

// 去除转义字符：https://www.cnblogs.com/leejersey/p/4568092.html


function clipboardSuccess() {
  Vue.prototype.$message({
    message: '复制成功',
    type: 'success',
    duration: 1500,
  })
}

function clipboardError() {
  Vue.prototype.$message({
    message: '复制失败',
    type: 'error',
  })
}


/**
 * 复制文案
 * v-copy="text"
 */
export const copy = {
  inserted(el, bind) {
    bind.def.update(el, bind)
  },

  update(el, bind) {
    let value = bind.value

    // 把br改成\n
    if (value) {
      value = bind.value.replace(/<br>/g, '\n')
      value = value.replace(/&#91;/g, '[')
      value = value.replace(/&#93;/g, ']')
    }
    
    if(value != bind.oldValue) {
      bind.clip = new Clipboard(el, {
        text: () => value,
      })
      bind.clip.on('success', () => {
        clipboardSuccess()
      })
      bind.clip.on('error', () => {
        clipboardError()
      })
    }
  },
  
  unbind(el, bind) {
    bind.clip && bind.clip.destroy()
  },
}

/**
 * 复制文案，没有提示
 * v-copy-notip="text"
 */
export const copyNotip = {
  inserted(el, bind) {
    bind.def.update(el, bind)
  },

  update(el, bind) {
    if(bind.value != bind.oldValue) {
      bind.clip = new Clipboard(el, {
        text: () => bind.value,
      })
    }
  },
  
  unbind(el, bind) {
    bind.clip && bind.clip.destroy()
  },
}

/**
 * 复制html
 * v-copyhtml="children selector"
 */
// export const copyhtml = {

// }